const OrderMediaItem = {
  OrderMediaItemEntity (entity) {
    return OrderMediaItemModel(entity);
  }
}

// 媒体实体
const OrderMediaItemModel = (entity) => {
  const convertDecimal = require("@/assets/js/convert").convertDecimal
  const dateJs = require("@/assets/js/date").default

  return {
    id: parseInt(entity.id || 0),
    contractMedia_Id: entity.contractMedia_Id || "",
    append: entity.append || "",
    category: entity.category || "",
    city: entity.city || "",
    contractId: parseInt(entity.contractId || 0),
    currency: entity.currency || "",
    endDate: dateJs.ConvertDate(entity.endDate) || null,
    format: entity.format || "",
    grossItemSum: convertDecimal(entity.grossItemSum || 0),
    grossRate: convertDecimal(entity.grossRate || 0),
    internalCode: entity.internalCode || "",
    isBonus: entity.isBonus || false,
    isToBeConfirmed: entity.isToBeConfirmed || false,
    mediaCode: entity.mediaCode || "",
    mediaId: entity.mediaId || "",
    mediaName: entity.mediaName || "",
    mediaRemark: entity.mediaRemark || "",
    noOfDays: parseInt(entity.noOfDays || 0),
    operator: entity.operator || "",
    planId: entity.planId || "",
    planName: entity.planName || "",
    priceOption: entity.priceOption || "",
    quantity: parseInt(entity.quantity || 0),
    rateOption: entity.rateOption || "",
    siteCode: entity.siteCode || "",
    subgroupCode: entity.subgroupCode || "",
    tier: entity.tier || "",
    totalProductionCost: convertDecimal(entity.totalProductionCost || 0),
    unitProductionCost: convertDecimal(entity.unitProductionCost || 0),
    unitQty: parseInt(entity.unitQty || 0),
    unitRate: convertDecimal(entity.unitRate || 0),
    visualDate: entity.visualDate,
    isExclusive: entity.isExclusive || false,
  }
}

export default OrderMediaItem
